"use client";

import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { scheduleIdle } from "@/lib/scheduleIdle";
import type { StrapiConverter } from "@/types";

interface ConvertersContextValue {
  converters: StrapiConverter[];
}

const ConvertersContext = createContext<ConvertersContextValue>({ converters: [] });

export function ConvertersProvider({
  converters: initialConverters,
  children,
}: {
  converters: StrapiConverter[];
  children: ReactNode;
}): React.ReactElement {
  const [converters, setConverters] = useState(initialConverters);

  useEffect(() => {
    if (initialConverters.length > 0) return;
    return scheduleIdle(() => {
      fetch("/api/converters")
        .then((res) => (res.ok ? res.json() : []))
        .then((data: unknown) => {
          if (Array.isArray(data) && data.length > 0) setConverters(data as StrapiConverter[]);
        })
        .catch(() => {});
    }, 2500);
  }, [initialConverters.length]);

  return (
    <ConvertersContext.Provider value={{ converters }}>
      {children}
    </ConvertersContext.Provider>
  );
}

export function useConverters(): ConvertersContextValue {
  return useContext(ConvertersContext);
}
